import React from 'react';
import cvPdfUrl from '../assets/files/Mina_Beiki_CV_2026.pdf';
import './Skills.css';

const skillGroups = [
  {
    title: 'Programming languages',
    items: ['Kotlin', 'Python', 'C', 'Java', 'JavaScript', 'HTML', 'CSS']
  },
  {
    title: 'Frameworks',
    items: ['React', 'Jupyter', 'Matplotlib', 'NumPy', 'Java Swing Framework']
  },
  {
    title: 'Software tools',
    items: [
      'Git',
      'Figma',
      'YouTrack',
      'Trello',
      'Jira',
      'Adobe Photoshop',
      'Adobe Illustrator',
      'Adobe Fresco'
    ]
  }
];

const Skills = () => {
  return (
    <section id="skills" className="skills">
      <div className="skills-inner">
        <header className="skills-header">
          <h2 className="skills-title">Skills & tools</h2>
          <p className="skills-lede">
            Main programming languages, frameworks, and software tools I have used and am familiar with.
          </p>
        </header>

        <div className="skills-bento">
          {skillGroups.map((group) => (
            <article
              key={group.title}
              className="skills-card"
            >
              <h3 className="skills-card-title">{group.title}</h3>
              <p className="skills-items">{group.items.join(', ')}</p>
            </article>
          ))}
        </div>

        <div className="skills-cv">
          <p className="skills-cv-text">Here you can download my newest CV </p>
          <a
            className="skills-cv-button"
            href={cvPdfUrl}
            download="Mina_Beiki_CV_2026.pdf"
          >
            Download CV (PDF)
          </a>
        </div>
      </div>
    </section>
  );
};

export default Skills;
